export const USER_ACCESSES = {
  MEMBER: 'Project Member',
  ADMIN: 'Project Admin',
};

export const DEFAULT_TRIAL_ACCESS_LEVELS = [
  {
    serviceName: 'projectAdministration',
    access: 'administrator',
  },
  {
    serviceName: 'documentManagement',
    access: 'administrator',
  },
  {
    serviceName: 'projectManagement',
    access: 'administrator',
  },
  {
    serviceName: 'costManagement',
    access: 'administrator',
  },
  {
    serviceName: 'quantification',
    access: 'none',
  },
  {
    serviceName: 'fieldManagement',
    access: 'administrator',
  },
  {
    serviceName: 'assets',
    access: 'administrator',
  },
  {
    serviceName: 'modelCoordination',
    access: 'none',
  },
  {
    serviceName: 'designCollaboration',
    access: 'none',
  },
  {
    serviceName: 'insight',
    access: 'administrator',
  },
];

export const PRODUCT_ACCESS_MOCK = [
  { access: 'administrator', key: 'cost' },
  { access: 'administrator', key: 'build' },
  { access: 'administrator', key: 'insight' },
  { access: 'administrator', key: 'projectAdministration' },
];

export const PROJECT_PRODUCT_MOCK = [
  { status: 'active', key: 'cost' },
  { status: 'active', key: 'build' },
  { status: 'active', key: 'insight' },
  { status: 'active', key: 'projectAdministration' },
  { status: 'active', key: 'modelCoordination' },
  { status: 'active', key: 'takeoff' },
  { status: 'inactive', key: 'autoSpecs' },
];

export const EVENT_BODY_MOCK = {
  access_level: 'Project Admin',
  account_admin: true,
  company: null,
  emails: 0,
  product_id: 'Docs',
  products: null,
  project_admin: true,
  role: null,
};
